global.FPS = 7
global.GRID = 16
global.MAP_WIDTH = Math.floor(528 / GRID)
global.MAP_HEIGHT = Math.floor(288 / GRID)

global.Dir = Object.freeze({
  LEFT: 'LEFT',
  RIGHT: 'RIGHT',
  UP: 'UP',
  DOWN: 'DOWN',
})

global.LEFT = 'LEFT'
global.RIGHT = 'RIGHT'
global.UP = 'UP'
global.DOWN = 'DOWN'

global.MAX_WATER = 7

global.Tiles = Object.freeze({
  GRASS: 'GRASS',
  DIRT: 'DIRT',
  SEEDS: 'SEEDS',
  FOOD: 'FOOD',
  WATER: 'WATER',
  ROCK: 'ROCK'
})

global.Crops = Object.freeze({
  CABBAGE: 'CABBAGE',
  STRAWBERRIES: 'STRAWBERRIES',
  WATERMELON: 'WATERMELON'
})

global.CropValue = Object.freeze({
  CABBAGE: 1,
  STRAWBERRIES: 2,
  WATERMELON: 3
})

global.Effects = Object.freeze({
  DRIP: {
    image: require('./assets/images/drip.png'),
    width: 11,
    height: 20,
    frames: 8,
    speed: 5
  },
  HEART: {
    image: require('./assets/images/heart.png'),
    width: 16,
    height: 16,
    frames: 5,
    speed: 5
  },
  SPARKLE: {
    image: require('./assets/images/sparkle.png'),
    width: 7,
    height: 9,
    frames: 5,
    speed: 4
  },
  SPLASH: {
    image: require('./assets/images/splash.png'),
    width: 7,
    height: 4,
    frames: 5,
    speed: 5
  }
})

global.Maps = Object.freeze({
  1: require('./assets/maps/map1_small.json'),
  2: require('./assets/maps/map2_small.json'),
  3: require('./assets/maps/map3_small.json'),
})